import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";
import { getHostHistory } from "../../store/host/host.action";

import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import dayjs from "dayjs";
import ServerPagination from "../../Pages/ServerPagination";

// anahtarlar sunucunun bekledigi degerler; etiketler Turkce
const TYPES = [
  ["call", "Görüşme"],
  ["gift", "Hediye"],
  ["coinPlan", "Satın alma"],
  ["admin", "Admin coin"],
];

const CALL_TR = {
  MissedCall: "Cevapsız",
  Outgoing: "Giden",
  Incoming: "Gelen",
};

const HostHistoryTable = (props) => {
  const { hostHistory, totalCoin, total } = useSelector((state) => state.host);
  const dispatch = useDispatch();

  const [data, setData] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [type, setType] = useState("call");

  const location = useLocation();
  const id = location.state.hostId;
  const history = useHistory();

  const handleInfo = () => history.push({ pathname: "/admin/host/hostProfile", state: { hostId: id } });

  const handleApply = (event, picker) => {
    setStartDate(dayjs(picker.startDate).format("YYYY-MM-DD"));
    setEndDate(dayjs(picker.endDate).format("YYYY-MM-DD"));
    setActivePage(1);
  };

  const handleCancel = (event, picker) => {
    picker?.element.val("");
    setStartDate("");
    setEndDate("");
    setActivePage(1);
  };

  useEffect(() => {
    dispatch(getHostHistory(id, type, activePage, rowsPerPage, startDate, endDate));
  }, [dispatch, id, type, activePage, rowsPerPage, startDate, endDate]);

  useEffect(() => {
    setData(hostHistory);
  }, [hostHistory]);

  const short = (s, n = 18) => (s && s.length > n ? s.substring(0, n) + "…" : s);
  const coinText = (n) => (Number(n) || 0).toLocaleString("tr-TR");
  const splitDate = (d) => {
    const p = (d || "").split(",");
    return { day: (p[0] || "").trim(), time: (p[1] || "").trim() };
  };

  const S = styles;

  const Empty = () => <div style={S.empty}>Bu aralıkta kayıt yok.</div>;

  const Row = ({ left, right, sub, badge, badgeStyle }) => (
    <div style={S.row}>
      <div style={S.rowLeft}>
        <div style={S.rowTitle}>
          {left}
          {badge && <span style={{ ...S.badge, ...(badgeStyle || {}) }}>{badge}</span>}
        </div>
        {sub && <div style={S.rowSub}>{sub}</div>}
      </div>
      <div style={S.rowRight}>{right}</div>
    </div>
  );

  const renderCall = () =>
    data?.length > 0 ? (
      data.map((d, i) => {
        const { day, time } = splitDate(d?.date);
        const tone =
          d?.callType === "MissedCall" ? S.badgeRed : d?.callType === "Incoming" ? S.badgeGreen : S.badgeBlue;
        return (
          <Row
            key={i}
            left={
              <span style={S.link} onClick={handleInfo}>
                @{short(d?.userName)}
              </span>
            }
            badge={CALL_TR[d?.callType] || d?.callType}
            badgeStyle={tone}
            sub={`${day} · ${time} · süre ${d?.duration || "00:00:00"}`}
            right={
              <span style={d?.isIncome === false ? S.minus : S.plus}>
                {d?.isIncome === false ? "−" : "+"}
                {coinText(d?.coin)}
              </span>
            }
          />
        );
      })
    ) : (
      <Empty />
    );

  const renderGift = () =>
    data?.length > 0 ? (
      data.map((d, i) => {
        const { day, time } = splitDate(d?.date);
        return (
          <Row
            key={i}
            left={
              <>
                <span style={S.muted}>Hediye ·&nbsp;</span>
                <span
                  style={S.link}
                  onClick={() => {
                    sessionStorage.setItem("hostId", d?.hostId);
                    handleInfo();
                  }}
                >
                  @{short(d?.userName)}
                </span>
              </>
            }
            sub={`${day} · ${time}`}
            right={
              <span style={d?.isIncome === true ? S.plus : S.minus}>
                {d?.isIncome === true ? "+" : "−"}
                {coinText(d?.coin)}
              </span>
            }
          />
        );
      })
    ) : (
      <Empty />
    );

  const renderPurchase = () =>
    data?.length > 0 ? (
      data.map((d, i) => (
        <Row
          key={i}
          left={short(d?.name)}
          badge={d?.paymentGateway}
          badgeStyle={S.badgeGrey}
          sub={dayjs(d?.createdAt).format("DD MMM YYYY · HH:mm")}
          right={<span style={S.money}>{d?.dollar} $</span>}
        />
      ))
    ) : (
      <Empty />
    );

  const renderAdmin = () =>
    data?.length > 0 ? (
      data.map((d, i) => {
        const { day, time } = splitDate(d?.date);
        return (
          <Row
            key={i}
            left={<span style={S.muted}>Admin işlemi</span>}
            sub={`${day} · ${time}`}
            right={
              <span style={d?.isIncome === true ? S.plus : S.minus}>
                {d?.isIncome === true ? "+" : "−"}
                {coinText(d?.coin)}
              </span>
            }
          />
        );
      })
    ) : (
      <Empty />
    );

  const current = TYPES.find(([k]) => k === type);

  return (
    <>
      <div className="row py-2">
        <div className="col-6">
          <h4 className="hostTitle">Yayıncı geçmişi</h4>
        </div>
        <div className="col-6">
          <div className="breadcrumb-four float-right">
            <ul className="breadcrumb">
              <li>
                <Link to="/admin/dashboard">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="feather feather-home"
                  >
                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                    <polyline points="9 22 9 12 15 12 15 22" />
                  </svg>
                </Link>
              </li>
              <li>
                <Link to="/admin/host"> Yayıncılar </Link>
              </li>
              <li className="active">
                <a href={() => false}> Geçmiş </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="row layout-top-spacing">
        <div className="col-lg-12 col-12 layout-spacing">
          <div className="statbox widget">
            <div className="widget-content widget-content-area" style={S.area}>
              {/* tur secimi + tarih araligi */}
              <div style={S.toolbar}>
                <div style={S.tabs}>
                  {TYPES.map(([key, label]) => (
                    <button
                      key={key}
                      type="button"
                      style={{ ...S.tab, ...(type === key ? S.tabOn : {}) }}
                      onClick={() => {
                        setType(key);
                        setActivePage(1);
                      }}
                    >
                      {label}
                    </button>
                  ))}
                </div>

                <div style={S.dateWrap}>
                  <DateRangePicker onApply={handleApply} onCancel={handleCancel}>
                    <input type="text" style={S.date} placeholder="Tarih aralığı seç" readOnly />
                  </DateRangePicker>
                  {startDate && (
                    <span style={S.dateShow}>
                      {startDate} → {endDate}
                    </span>
                  )}
                </div>
              </div>

              {/* ozet */}
              <div style={S.summary}>
                <div>
                  <div style={S.summaryLabel}>{current ? current[1] : ""} kayıtları</div>
                  <div style={S.summaryValue}>{total || 0} kayıt</div>
                </div>
                {type !== "coinPlan" && (
                  <div style={{ textAlign: "right" }}>
                    <div style={S.summaryLabel}>Toplam coin</div>
                    <div style={{ ...S.summaryValue, color: "#b45309" }}>{coinText(totalCoin)}</div>
                  </div>
                )}
              </div>

              <div style={S.list}>
                {type === "call" && renderCall()}
                {type === "gift" && renderGift()}
                {type === "coinPlan" && renderPurchase()}
                {type === "admin" && renderAdmin()}
              </div>

              <ServerPagination
                activePage={activePage}
                rowsPerPage={rowsPerPage}
                userTotal={total}
                handleRowsPerPage={(v) => {
                  setRowsPerPage(v);
                  setActivePage(1);
                }}
                handlePageChange={(p) => setActivePage(p)}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const styles = {
  area: { padding: 18 },
  toolbar: {
    display: "flex",
    flexWrap: "wrap",
    gap: 12,
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 16,
  },
  tabs: { display: "flex", gap: 8, flexWrap: "wrap" },
  tab: {
    border: "1px solid #e3e7ef",
    background: "#fff",
    color: "#5b6478",
    borderRadius: 10,
    padding: "8px 16px",
    fontWeight: 600,
    fontSize: 14,
    cursor: "pointer",
  },
  tabOn: { background: "#4361ee", borderColor: "#4361ee", color: "#fff" },
  dateWrap: { display: "flex", alignItems: "center", gap: 10 },
  date: {
    border: "1px solid #e3e7ef",
    borderRadius: 10,
    padding: "9px 14px",
    fontSize: 14,
    outline: "none",
    minWidth: 190,
    cursor: "pointer",
    background: "#fff",
  },
  dateShow: { fontSize: 13, color: "#6b7280", fontWeight: 600 },
  summary: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background: "#f6f8fc",
    border: "1px solid #eceff5",
    borderRadius: 12,
    padding: "14px 18px",
    marginBottom: 14,
  },
  summaryLabel: { fontSize: 12, color: "#8b93a7", fontWeight: 600 },
  summaryValue: { fontSize: 20, fontWeight: 700, color: "#1b2334", marginTop: 2 },
  list: { display: "flex", flexDirection: "column", gap: 8 },
  row: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    border: "1px solid #eceff5",
    borderRadius: 12,
    padding: "12px 16px",
    background: "#fff",
  },
  rowLeft: { flex: 1, minWidth: 0 },
  rowTitle: { display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", fontSize: 15, color: "#1b2334" },
  rowSub: { marginTop: 3, fontSize: 12.5, color: "#8b93a7" },
  rowRight: { fontSize: 16, fontWeight: 700, whiteSpace: "nowrap" },
  link: { color: "#3056d3", fontWeight: 700, cursor: "pointer" },
  muted: { color: "#6b7280" },
  badge: { fontSize: 11, fontWeight: 700, borderRadius: 20, padding: "2px 10px" },
  badgeRed: { background: "#ffe3e3", color: "#b42318" },
  badgeGreen: { background: "#e3f9ec", color: "#067647" },
  badgeBlue: { background: "#e5edff", color: "#2c4bbd" },
  badgeGrey: { background: "#eef1f6", color: "#4b5563" },
  plus: { color: "#067647" },
  minus: { color: "#b42318" },
  money: { color: "#1b2334" },
  empty: { textAlign: "center", color: "#8b93a7", padding: "48px 0", fontSize: 15 },
};

export default connect(null, { getHostHistory })(HostHistoryTable);
